import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Swal from 'sweetalert2';
import headerimage from '../../assets/images/ascas.svg';
import SinglePatientInfo from '../../Components/Global_Components/common/SinglePatientInfo';
import ReportFormInputWithLabel from '../../Components/Global_Components/form/ReportFormInputWithLabel';
import SelectField from '../../Components/Global_Components/form/SelectField';
import TemplateTable from '../../Components/Global_Components/TemplateTable/TemplateTable';
import Headers from '../../Components/Header/Headers';
import {PrescriptionFooter} from '../../Components/Prescription Footer/PrescriptionFooter';
import {postPrescriptionTemplate} from '../../Redux/Thunk/Actions';
import {handleNill, renderDynamicTable, renderReportfield} from '../../utils/templateUtils';
import './icsi3rdMonth.scss';

export default function ICSI3rdMonth(props) {
  const [showTables, setShowTables] = useState({
    medication: true,
    investigations: true
  });
  const [formData, setFormData] = useState({});
  const [show, setshow] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const patientId = useSelector(state => state.counter.patientid);

  const [medicationRows, setMedicationRows] = useState([
    { sno: "1", drug: "Globac XT / Ferronomic Plus / Furnext", genericName: "Iron supplement (Ferrous ascorbate + folic acid)", dosage: "1 tab", freq: "0-1-0", route: "Oral", timing: "After food", duration: "30 days", remarks: "Avoid tea/coffee; not with calcium" },
    { sno: "2", drug: "Tricium XT / Ultra Ca", genericName: "Calcium + Vitamin D3", dosage: "1 tab", freq: "1-0-1", route: "Oral", timing: "After food", duration: "30 days", remarks: "4-hour gap from iron" },
    { sno: "3", drug: "Folvista / Cor 3 / MecobMB", genericName: "L-Methylfolate + Pyridoxine + Cyanocobalamin", dosage: "1 tab", freq: "0-1-0", route: "Oral", timing: "After food", duration: "30 days", remarks: "Methylation support" },
    { sno: "4", drug: "C-Vit / Celin", genericName: "Vitamin C", dosage: "500 mg", freq: "0-1-0", route: "Oral", timing: "After food", duration: "30 days", remarks: "Improves iron absorption" },
    { sno: "5", drug: "Neuroplex / Neurobion", genericName: "Vitamin B-complex", dosage: "1 tab", freq: "OD", route: "Oral", timing: "After food", duration: "30 days", remarks: "Hemoglobin support" },
    { sno: "6", drug: "Vivamom (Sugar free)", genericName: "Protein + DHA + multivitamins", dosage: "2 tsp", freq: "OD/BD", route: "Oral (with milk)", timing: "Morning / Night", duration: "30 days", remarks: "Optional supplement" },
    { sno: "7", drug: "Progynova", genericName: "Estradiol Valerate", dosage: "2 mg", freq: "1-0-1", route: "Oral", timing: "After food", duration: "5 days then stop", remarks: "Endometrial support" },
    { sno: "8", drug: "DydroficDuphaston / Dydroboon", genericName: "Dydrogesterone", dosage: "10 mg", freq: "1-1-1", route: "Oral", timing: "After food", duration: "Till 20 weeks", remarks: "Luteal support" },
    { sno: "9", drug: "Strone AQ / Aqgest", genericName: "Progesterone (aqueous)", dosage: "50 mg", freq: "1-0-0", route: "SC / IM", timing: "Morning", duration: "As advised", remarks: "Luteal support" },
    { sno: "10", drug: "Gufigest / Gestobond", genericName: "Natural Micronised Progesterone", dosage: "400 mg", freq: "0-0-1 / BD", route: "Vaginal", timing: "Night", duration: "Till 20 weeks", remarks: "Insert after washing hands" },
    { sno: "11", drug: "Ecospirin 75/150", genericName: "Aspirin", dosage: "75 / 150 mg", freq: "0-1-0", route: "Oral", timing: "After food", duration: "Till 34 weeks", remarks: "Improve uterine blood flow" },
    { sno: "12", drug: "Evaparin/Lonopin", genericName: "Enoxaparin", dosage: "0.4 mL", freq: "1-0-0", route: "SC", timing: "Morning", duration: "As advised", remarks: "Anticoagulant" },
    { sno: "13", drug: "Glycomet 500", genericName: "Metformin", dosage: "500 mg", freq: "1-0-1 / OD", route: "Oral", timing: "After food", duration: "As advised", remarks: "Insulin resistance / GDM" },
    { sno: "14", drug: "Thyronorm", genericName: "Levothyroxine", dosage: "As per TSH", freq: "1-0-0", route: "Oral", timing: "Empty stomach", duration: "As advised", remarks: "No food 30 min" },
    { sno: "15", drug: "V-Wash", genericName: "pH-balanced intimate wash", dosage: "Coin size", freq: "PRN", route: "External", timing: "—", duration: "As needed", remarks: "Hygiene support" },
    { sno: "16", drug: "Candid CL (if needed)", genericName: "Clindamycin + Clotrimazole", dosage: "1 pessary", freq: "OD", route: "Vaginal", timing: "Night", duration: "3 days/month", remarks: "If discharge" },
    { sno: "17", drug: "Td Vaccine", genericName: "Tetanus + Diphtheria toxoid", dosage: "0.5 mL", freq: "—", route: "IM", timing: "—", duration: "As schedule", remarks: "Maternal immunization" },
    { sno: "18", drug: "Influvac Tetra", genericName: "Quadrivalent Influenza Vaccine", dosage: "0.5 mL", freq: "Single dose", route: "IM", timing: "—", duration: "Once (seasonal)", remarks: "Prevent influenza" },
  ]);

  const medicationHeaders = [
    {key: 'sno', label: 'S. No'},
    {key: 'drug', label: 'Drug Name'},
    {key: 'genericName', label: 'Generic Name'},
    {key: 'dosage', label: 'Dose'},
    {key: 'freq', label: 'Frequency'},
    {key: 'route', label: 'Route'},
    {key: 'timing', label: 'Timing'},
    {key: 'duration', label: 'Duration'},
    {key: 'remarks', label: 'Remarks'}
  ];

  const handleChange = e => {
    const {name, value} = e.target;
    setFormData(prev => ({...prev, [name]: value}));
  };

  const [investigationRows, setInvestigationRows] = useState([]);

  const investigationHeaders = [
    {key: 'name', label: 'Investigation'},
    {key: 'value', label: 'Result'}
  ];

  const handlesubmit = () => {
    try {
        if (props.patientsData.id !== '' && props.patientsData.p_uhid !== '' && /^(ASCAS|VDASCAS)\d+$/i.test((props.patientsData.p_uhid || '').trim())) {
       setshow(true);
        setTimeout(async () => {
          const htmlPayload = document.getElementById('icsi3rdMonthReportWrap').innerHTML;

          const payload = {
            payload: {
              prescription_template: htmlPayload,
              patient_id: patientId,
              description: '',
              template_type: 'ICSI 3 rd Month'
            }
          };

          props.loaderchange(true);
          const patentDetails = postPrescriptionTemplate(payload);
          const response = await dispatch(patentDetails);
          if (response?.payload?.status?.code === 200) {
            props.loaderchange(false);
            navigate('/PatientView');
          } else {
            props.loaderchange('false');
            props.popupalert('true');
            props.popuptext('Network went wrong, Please try after some time.');
            setTimeout(() => {
              props.popupalert('false');
            }, 2000);
          }
        }, 3000);
      } else {
        Swal.fire({
          title: 'Error.',
          text: 'Please enter valid patient id.',
          icon: 'error',
          showConfirmButton: false,
          timer: 1500
        });
      }
    } catch (error) {
      console.error('An error occurred:', error);
    }
  };

  return (
    <div id='ICSI3rdMonthTemplate'>
      <div className='ICSI3rdMonthTemplate'>
        <div style={{width: '100%', display: 'block'}} id='patientInfo1'>
          <div style={{width: '100%'}}>
            <img className='header_image' src={headerimage} style={{width: '100%', margin: '0 auto'}}></img>
          </div>
          <h2 style={{display: 'flex', justifyContent: 'center'}}>ANTENATAL VISIT SUMMARY – NT SCAN ICSI</h2>

          <SinglePatientInfo patientsData={props.patientsData} handleChange={handleChange} />
        </div>
        <div className='detail'>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='LMP:' name='lmp' value={formData.lmp} required={false} onChange={handleChange} inputClassName='show' type='date' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='ET:' name='et' value={formData.et} required={false} onChange={handleChange} inputClassName='show' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='EDD:' name='edd' value={formData.edd} required={false} onChange={handleChange} inputClassName='show' type='date' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='POG:' name='pog' value={formData.pog} required={false} onChange={handleChange} inputClassName='show' />
            </div>
          </div>
          <h4>NT SCAN FINDINGS:</h4>
          <div className='row'>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='NT:' name='nt' value={formData.nt} required={false} onChange={handleChange} inputClassName='show' endLabel='mm' />
            </div>
            <div className='col-md-3'>
              <SelectField
                label='NB'
                name='nb'
                value={formData.nb}
                options={[
                  {label: 'Present', value: 'Present'},
                  {label: 'Absent', value: 'Absent'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='80px'
              />
            </div>
            <div className='col-md-3'>
              <SelectField
                label='TR'
                name='tr'
                value={formData.tr}
                options={[
                  {label: 'Present', value: 'Present'},
                  {label: 'Absent', value: 'Absent'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='80px'
              />
            </div>
            <div className='col-md-3'>
              <SelectField
                label='DV'
                name='dv'
                value={formData.dv}
                options={[
                  {label: 'Normal', value: 'Normal'},
                  {label: 'Abnormal', value: 'Abnormal'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
                minWidth='80px'
              />
            </div>
            <div className='col-md-3'>
              <ReportFormInputWithLabel label='Cervix:' name='cervix' value={formData.cervix} required={false} onChange={handleChange} inputClassName='show' endLabel='cm' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Placenta Position:' name='placentaPosition' value={formData.placentaPosition} required={false} onChange={handleChange} inputClassName='show' minWidth='180px' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-6'>
              <SelectField
                label='Screening Discussed'
                name='screening'
                value={formData.screening}
                options={[
                  {label: 'Dual Marker', value: 'Dual Marker'},
                  {label: 'NIPT', value: 'NIPT'},
                  {label: 'PLGF', value: 'PLGF'},
                  {label: 'PNGF', value: 'PNGF'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <h4 className='pt-4'>ON EXAMINATION</h4>
          <div className='row'>
            <div className='col-md-4'>
              <SelectField
                label='Pallor'
                name='pallor'
                value={formData.pallor}
                options={[
                  {label: 'Yes', value: 'yes'},
                  {label: 'No', value: 'no'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
            <div className='col-md-4'>
              <SelectField
                label='Pedal Edema'
                name='pedalEdema'
                value={formData.pedalEdema}
                options={[
                  {label: 'Yes', value: 'yes'},
                  {label: 'No', value: 'no'}
                ]}
                onChange={handleChange}
                placeholder='Please select'
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Pulse Rate:' name='pulse' value={formData.pulse} required={false} onChange={handleChange} inputClassName='show' endLabel='/min' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='BP:' name='bp' value={formData.bp} required={false} onChange={handleChange} inputClassName='show' endLabel='mmHg' />
            </div>
            <div className='col-md-4'>
              <ReportFormInputWithLabel label='Weight:' name='weight' value={formData.weight} required={false} onChange={handleChange} inputClassName='show' endLabel='kg' />
            </div>
          </div>
          <div className='row'>
            <div className='col-md-4'>
              <ReportFormInputWithLabel
                label='Pre-pregnancy Weight:'
                name='prePregnancyWeight'
                value={formData.prePregnancyWeight}
                required={false}
                onChange={handleChange}
                inputClassName='show'
                endLabel='kg'
                minWidth='220px'
              />
            </div>
          </div>

          {showTables.medication && (
            <TemplateTable
              id='medication'
              title='💊 ANTENATAL MEDICATION CHART – NT SCAN STAGE'
              headers={medicationHeaders}
              rows={medicationRows}
              onRowsChange={(id, newRows) => setMedicationRows(newRows)}
              enableActions={true}
              onNill={() => handleNill('medication', setShowTables)}
            />
          )}

          <div className='d-flex align-items-start py-2'>
            <label htmlFor='investigations' className='fw-bold' style={{width: '180px'}}>
              🔬 INVESTIGATIONS:
            </label>
            <textarea className='Textarea' placeholder='INVESTIGATIONS' id='investigations' name='investigations' onChange={handleChange} rows='3' cols='100'></textarea>
          </div>

          <div className='bulletin'>
            <h4>✅ PATIENT EDUCATION & INSTRUCTIONS</h4>
            <ul className='ms-5'>
              <li>Apply for PICME number at your nearest government hospital (bring Aadhaar + photo)</li>
              <li>Vomiting usually reduces after 14 weeks; start iron/calcium if not tolerable now</li>
              <li>Iron and calcium must be taken with 4 hours gap</li>
              <li>Avoid tea, coffee, biscuits with iron tablets</li>
              <li>Double marker result takes 7–10 days from scan date; follow-up with Dr. Aishwarya</li>
              <li>
                Emergency contact:<b> +91-9342521779</b>
              </li>
              <li>Follow a routine of 3 full meals + 3 healthy snacks daily</li>
              <li>Safe exercises: walking, swimming, yoga, cycling, light jogging, Zumba</li>
              <li>Watch Doctor Mommies YouTube → “2nd Trimester Dos and Don’ts”</li>
            </ul>
          </div>

          <div className='d-flex align-items-start py-2'>
            <label htmlFor='advice' className='fw-bold' style={{width: '180px'}}>
              ADVICE:
            </label>
            <textarea className='Textarea' placeholder='ADVICE' id='advice' name='advice' onChange={handleChange} rows='3' cols='100'></textarea>
          </div>
          <p className='pt-3' style={{fontWeight: '600'}}>
            NEXT REVIEW - <input name='nextReview' onChange={handleChange} type='date' className={`createTime ${show ? 'hide' : 'show'}`} />
          </p>
        </div>
        <div className={`Footer ${show ? 'hide' : 'show'}`}>
          <button onClick={handlesubmit} className='Button_Create'>
            Add Report
          </button>
        </div>
      </div>
      <div id='icsi3rdMonthReport'>
        <div id='icsi3rdMonthReportWrap'>
          <Headers />
          <p className='Dani'></p>
          <div className='patient' style={{border: '1px solid black', borderRadius: '10px', marginBottom: '5px'}}>
            <div className='nameToAgeContainer' style={{display: 'flex', marginBottom: '5px'}}>
              {renderReportfield('Patient Name :', `${props.patientsData.titles} ${props.patientsData.first_name} ${props.patientsData.last_name}`)}
              {renderReportfield('Patient ID :', props.patientsData.p_uhid)}
              {renderReportfield('Gender :', props.patientsData.gender)}
              {renderReportfield('Age :', props.patientsData.age)}
            </div>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', justifyContent: 'center', marginTop: '5px'}}>
            <h4 style={{fontWeight: 600, color: '#333', marginBottom: '15px'}}>ANTENATAL VISIT SUMMARY – NT SCAN ICSI</h4>
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('LMP:', formData.lmp?.split('-').reverse().join('-'))}
            {renderReportfield('ET:', formData.et)}
            {renderReportfield('EDD:', formData.edd?.split('-').reverse().join('-'))}
            {renderReportfield('POG:', formData.pog)}
          </div>
          <div style={{fontWeight: 'bold'}}>NT SCAN FINDINGS:</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('NT:', `${formData.nt || ''} mm`)}
            {renderReportfield('NB:', formData.nb)}
            {renderReportfield('TR:', formData.tr)}
            {renderReportfield('DV:', formData.dv)}
            {renderReportfield('Cervix:', `${formData.cervix || ''} cm`)}
            {renderReportfield('Placenta Position:', formData.placentaPosition)}
          </div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>{renderReportfield('Screening Discussed:', formData.screening)}</div>
          <div style={{fontWeight: 'bold'}}>ON EXAMINATION</div>
          <div style={{display: 'flex', flexWrap: 'wrap', marginBottom: '5px'}}>
            {renderReportfield('Pallor:', formData.pallor ? 'Yes' : 'No')}
            {renderReportfield('Pedal Edema:', formData.pedalEdema ? 'Yes' : 'No')}
            {renderReportfield('Pulse Rate:', `${formData.pulse || ''} / min`)}
            {renderReportfield('BP:', `${formData.bp || ''} mmHg`)}
            {renderReportfield('Weight:', `${formData.weight || ''} kg`)}
            {renderReportfield('Pre-pregnancy Weight:', `${formData.prePregnancyWeight || ''} kg`)}
          </div>

          {showTables.medication &&
            renderDynamicTable(
              '💊 ANTENATAL MEDICATION CHART – NT SCAN STAGE',
              ['S. No', 'Drug Name', 'Generic Name', 'Dose', 'Frequency', 'Route', 'Timing', 'Duration', 'Remarks'],
              ['sno', 'drug', 'genericName', 'dosage', 'freq', 'route', 'timing', 'duration', 'remarks'],
              medicationRows
            )}

          <div style={{display: 'flex', marginBottom: '5px'}}>{renderReportfield('🔬 INVESTIGATIONS:', formData.investigations)}</div>

          <div style={{marginTop: '10px'}}>
            <h6 style={{fontWeight: 600}}>✅ PATIENT EDUCATION & INSTRUCTIONS</h6>
            <ol style={{marginLeft: '30px'}}>
              <li>Apply for PICME number at your nearest government hospital (bring Aadhaar + photo)</li>
              <li>Vomiting usually reduces after 14 weeks; start iron/calcium if not tolerable now</li>
              <li>Iron and calcium must be taken with 4 hours gap</li>
              <li>Avoid tea, coffee, biscuits with iron tablets</li>
              <li>Double marker result takes 7–10 days from scan date; follow-up with Dr. Aishwarya</li>
              <li>
                Emergency contact:<b> +91-9342521779</b>
              </li>
              <li>Follow a routine of 3 full meals + 3 healthy snacks daily</li>
              <li>Safe exercises: walking, swimming, yoga, cycling, light jogging, Zumba</li>
              <li>Watch Doctor Mommies YouTube → “2nd Trimester Dos and Don’ts”</li>
            </ol>
          </div>

          <div style={{marginBottom: '5px'}}>
            <div style={{fontWeight: '600', margin: '0 10px 10px 10px'}}>ADVICE:</div>
            <pre style={{margin: '0 10px 10px 10px', fontFamily: 'inherit', whiteSpace: 'pre-wrap'}}>{formData.advice}</pre>
          </div>
          <div style={{marginTop: '20px', borderBottom: '1px solid #ddd', paddingBottom: '15px'}}>
            <div style={{marginTop: '5px'}}>{renderReportfield('Next Review : ', formData.nextReview?.split('-').reverse().join('-'))}</div>
          </div>
          <PrescriptionFooter />
        </div>
      </div>
    </div>
  );
}
